export default "__VITE_ASSET__BSmTzICr__"